import { ChangeDetectionStrategy, Component, Inject, Input, Optional } from '@angular/core';
import { MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA } from '@angular/material/legacy-snack-bar';

import { Observable } from 'rxjs';

import { AsyncPipe, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CustomisableVariables } from '@shared/models/customisable-variables';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';

@Component({
  selector: 'ten-generic-api-error',
  templateUrl: './generic-api-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, TranslateModule, AsyncPipe],
})
export class GenericApiErrorComponent {
  @Input() public errorCode: number;

  public customisableVariables: Observable<CustomisableVariables> = this.customisableVariablesService.variables;

  constructor(
    @Optional() @Inject(MAT_SNACK_BAR_DATA) public errorMessage: string,
    private customisableVariablesService: CustomisableVariablesService
  ) {}
}
